import type { LoginControllerReturn } from "@Front/Components/Layouts/Login/hooks/useLoginController";
import { LoginStep } from "@Front/Components/Layouts/Login/hooks/loginSteps";
import {
	renderLoginCredentialEmailStep,
	renderLoginCredentialNewPasswordStep,
	renderLoginCredentialPasswordForgottenStep,
	renderLoginCredentialPasswordStep,
	renderLoginCredentialTotpStep,
} from "./loginCredentialStepPanelCases";

export function loginCredentialStepPanel(step: LoginStep, controller: LoginControllerReturn): React.JSX.Element | null {
	switch (step) {
		case LoginStep.EMAIL:
			return renderLoginCredentialEmailStep(controller);
		case LoginStep.TOTP:
			return renderLoginCredentialTotpStep(controller);
		case LoginStep.PASSWORD:
			return renderLoginCredentialPasswordStep(controller);
		case LoginStep.NEW_PASSWORD:
			return renderLoginCredentialNewPasswordStep(controller);
		case LoginStep.PASSWORD_FORGOTTEN:
			return renderLoginCredentialPasswordForgottenStep(controller);
		default:
			return null;
	}
}
